var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OutreachRequestsTable',{attrs:{"items":_vm.outreachRequests,"columns":_vm.columns}})}
var staticRenderFns = []

export { render, staticRenderFns }